var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dean-tooltip"},[_vm._t("activator"),_c('div',{staticClass:"text"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }